import React, { useState, useEffect } from 'react';
import { ICellEditorParams } from 'ag-grid-community';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useDispatch, useSelector } from 'react-redux';
import { updateCertDeadlineDate } from 'src/redux/slices/RentersDashboard/RentersDashboardSlice';
import { AppDispatch } from 'src/redux/store';
import { fDisplayDate, formatDatePost } from 'src/utils/formatTime';
import { RootState } from 'src/redux/rootReducerType';
import { Typography } from '@mui/material';

interface AGDatePickerProps extends ICellEditorParams {
  certificationId: string;
}

const AGDatePicker: React.FC<AGDatePickerProps> = (props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { certificationId } = props;

  const isBulkCommunications = useSelector(
    (state: RootState) => state.rentersDashboard.isBulkCommunications
  );

  const [value, setValue] = useState<Date | null>(() => {
    if (!props.value) {
      return null;
    }
    const [year, month, day] = props.value.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date;
  });

  // Sync local state with prop changes (e.g., after bulk updates)
  useEffect(() => {
    if (props.value) {
      const [year, month, day] = props.value.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      setValue(date);
    } else {
      setValue(null);
    }
  }, [props.value]);

  const handleDateChange = async (newDate: Date | null): Promise<void> => {
    setValue(newDate);
    if (newDate) {
      const dateToPost = formatDatePost(newDate);
      const payload = {
        certification: certificationId,
        deadline_date: dateToPost,
      };
      try {
        await dispatch(updateCertDeadlineDate({ payload }));
      } catch (error) {
        console.error('Failed to update deadline date:', error);
      }
    }
  };

  return isBulkCommunications ? (
    <Typography
      sx={{
        fontSize: 13,
      }}
    >
      {fDisplayDate(value)}
    </Typography>
  ) : (
    <DesktopDatePicker
      value={value}
      format="MM/dd/yyyy"
      onChange={handleDateChange}
      onClose={props.stopEditing}
      slotProps={{
        textField: {
          size: 'small',
          fullWidth: true,
          sx: {
            '& .MuiInputBase-root': {
              fontSize: 13,
              minHeight: 20,
            },
            '& .MuiButtonBase-root': {
              padding: '0 4px 0 0',
            },
            '& .MuiSvgIcon-root': {
              padding: '2px',
            },
          },
          InputProps: {
            sx: {
              paddingHorizontal: 10,
            },
          },
        },
      }}
    />
  );
};

export default AGDatePicker;
